import { APPOINTMENT_STATUS } from "../enums/appointment";
import { QUEUE_TYPE } from "../enums/queue";
import { AllQueuesData, AppointmentConfigs } from "../types/appointment";

export const BookedQueueStatus = [
  APPOINTMENT_STATUS.BOOKED,
  APPOINTMENT_STATUS.PARKED,
];

export const OpdQueueStatus = [
  APPOINTMENT_STATUS.CHECKED_IN,
  APPOINTMENT_STATUS.ONGOING,
];

export const CompletedQueueStatus = [
  APPOINTMENT_STATUS.COMPLETED,
  APPOINTMENT_STATUS.COMPLETED_NO_PRESCRIPTION,
];

export const OtherQueueStatus = [
  APPOINTMENT_STATUS.CANCELLED,
  APPOINTMENT_STATUS.STAFF_CANCELLED,
  APPOINTMENT_STATUS.DOCTOR_CANCELLED,
  APPOINTMENT_STATUS.RESCHEDULED,
  APPOINTMENT_STATUS.STAFF_RESCHEDULED,
  APPOINTMENT_STATUS.DOCTOR_RESCHEDULED,
  APPOINTMENT_STATUS.ABORTED,
  APPOINTMENT_STATUS.NO_SHOW,
  APPOINTMENT_STATUS.NO_SHOW_DOCTOR,
  APPOINTMENT_STATUS.NO_SHOW_STAFF,
];

export const FollowupQueueStatus = [
  APPOINTMENT_STATUS.INITIATED,
  APPOINTMENT_STATUS.RESERVED,
  APPOINTMENT_STATUS.PROVISIONAL_CANCELLED,
  APPOINTMENT_STATUS.RESCHEDULED,
];

export const queueTypeMapping: Record<
  QUEUE_TYPE | string,
  keyof AllQueuesData
> = {
  billing: "bookedAppointments",
  booked: "bookedAppointments",
  checkin: "opdAppointments",
  completed: "completedAppointments",
  followup: "followupAppointments",
  others: "otherAppointments",
  requested: "requestedAppointments",
};

export const appointmentConfigTitleMapping: Partial<
  Record<keyof AppointmentConfigs["apt_config"], string>
> = {
  pre_consulation_notes: "Enable Pre-Consultation Notes",
  allow_clinic_booking: "Allow Appointments to be booked at a clinic level",
  //   "Allow Appointments to be booked at a clinic level by Staff / Doctor",
  allow_slot_overbooking: "Allow Slot Overbooking",
  allow_pt_multi_apt:
    "Allow Multiple appointments for the same patient in a day",
};
